// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"vu_a bhe_b"};